module.exports = __webpack_public_path__ + "static/media/logo.2ca75633.mp4";